export { default } from './FormDialog';



// WEBPACK FOOTER //
// ./src/components/molecules/FormDialog/index.js